var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      style: _vm.css,
      attrs: {
        disabled: _vm.disabled,
        filterable: "",
        remote: "",
        "value-key": "id",
        "remote-method": _vm.loadMerchantList,
        placeholder: "输入商家名字或编号搜索",
        clearable: ""
      },
      on: { change: _vm.onChange },
      model: {
        value: _vm.merchant,
        callback: function($$v) {
          _vm.merchant = $$v
        },
        expression: "merchant"
      }
    },
    _vm._l(_vm.merchantList, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.name + "(" + item.code + ")", value: item }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-949aec9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-949aec9a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/MerchantSearch.vue
// module id = 812
// module chunks = 75